"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeHeaderMetadataValueClass = exports.placeHeaderMetadataLabelClass = exports.PlaceHeaderMetadataItem = exports.PlacePageActionsMenu = exports.PlacePageTitle = exports.placePageIconClass = exports.placePageIconContainerClass = exports.PlacePageMastheadRowContainer = exports.PlacePageMastheadContainer = exports.PlacePageTitleContainer = exports.PlacePageHeader = void 0;
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("./LayoutComponents");
var LayoutStyles_1 = require("./LayoutStyles");
var StyleFunctions_1 = require("./StyleFunctions");
var VizPortalStyles_1 = require("./VizPortalStyles");
var Typography = widgets_1.TabStyles.Typography;
var Spacing = widgets_1.TabStyles.Spacing;
exports.PlacePageHeader = (0, LayoutComponents_1.divWithStyle)('PlacePageHeader', VizPortalStyles_1.headerPaddingStyle);
exports.PlacePageTitleContainer = (0, LayoutComponents_1.divWithStyle)('PlacePageTitleContainer', LayoutStyles_1.flexRowStyle);
exports.PlacePageMastheadContainer = (0, LayoutComponents_1.divWithStyle)('PlacePageMastheadContainer', __assign(__assign({}, LayoutStyles_1.flexColumnStyle), { minWidth: 0 }));
exports.PlacePageMastheadRowContainer = (0, LayoutComponents_1.divWithStyle)('PlacePageMastheadRowContainer', __assign(__assign({}, LayoutStyles_1.flexRowStyle), { flex: '1 1 auto', marginBottom: Spacing.MediumSpace, minWidth: 0 }));
exports.placePageIconContainerClass = (0, StyleFunctions_1.cssClass)('PlacePageIconContainer', VizPortalStyles_1.headerIconContainerStyle);
exports.placePageIconClass = (0, StyleFunctions_1.cssClass)('PlacePageIcon', VizPortalStyles_1.headerIconStyle);
exports.PlacePageTitle = (0, LayoutComponents_1.divWithStyle)('PlacePageTitle', VizPortalStyles_1.placeHeaderTitleStyle);
exports.PlacePageActionsMenu = (0, LayoutComponents_1.divWithStyle)('PlacePageActionsMenu', VizPortalStyles_1.actionsMenuStyle);
exports.PlaceHeaderMetadataItem = (0, LayoutComponents_1.divWithStyle)('PlaceHeaderMetadataItem', {
    fontSize: Typography.Sizing.Default,
    color: Typography.Color.Disabled,
    paddingRight: Spacing.LargeSpace,
    verticalAlign: 'middle',
    alignItems: 'center',
    display: 'inline-flex',
});
exports.placeHeaderMetadataLabelClass = (0, StyleFunctions_1.cssClass)('placeHeaderMetadataLabel', __assign(__assign({}, VizPortalStyles_1.vizPortalFontStyle), { paddingRight: widgets_1.TabStyles.Spacing.DefaultSpace }));
exports.placeHeaderMetadataValueClass = (0, StyleFunctions_1.cssClass)('placeHeaderMetadataValue', __assign({}, VizPortalStyles_1.vizPortalLowDpiFontStyle));
//# sourceMappingURL=PlaceStyles.js.map